
// export const logout = ( state ) => {
// }

export const setCountries = (state, countries) => {
    state.countries = countries
}

export const setCountriesSelectable = (state, countries) => {
    state.countriesSelectable = countries
}

export const setCountriesPaginated = (state, countriesPaginatedData) => {
    state.countriesPaginatedData = countriesPaginatedData
}

export const setCountryDetail = (state, country) => {
    state.country = country
}

export const saveNewCountries = (state, country) => {
    state.countries.unshift(country)
    state.createdData = country;
}

export const saveUpdatedCountry = (state, country) => {
    state.countries.unshift(country)
    state.updatedData = country;
}

export const setDeleteCountry = (state, country) => {
    
    state.countriesPaginatedData.data.filter(x => x.id !== country.id);
    state.deletedData = country
}

export const setCountryIsLoading = (state, isLoading) => {
    state.isLoading = isLoading
}

export const setCountryIsCreating = (state, isCreating) => {
    state.isCreating = isCreating
}

export const setCountryIsUpdating = (state, isUpdating) => {
    state.isUpdating = isUpdating
}

export const setCountryIsDeleting = (state, isDeleting) => {
    state.isDeleting = isDeleting
}
